/**
 * Genera una cadena de texto en formato vCard
 * @param {string} name - Nombre
 * @param {string} phoneNumber - Número de teléfono
 * @param {string} email - Correo electrónico
 * @param {string} lastName - Apellidos (opcional)
 * @param {string} company - Organización (opcional)
 * @param {string} jobTitle - Cargo (opcional)
 * @returns {string} - Cadena de texto en formato vCard
 */
export function generateVcard(name, phoneNumber, email, lastName = "", company = "", jobTitle = "") {
  let vcard = `BEGIN:VCARD
VERSION:3.0
FN:${name} ${lastName}
N:${lastName};${name};;;
TEL;TYPE=CELL:${phoneNumber}
EMAIL:${email}
ORG:${company}`

  if (jobTitle) {
    vcard += `\nTITLE:${jobTitle}`
  }
  
  vcard += '\nEND:VCARD'
  return vcard
}